module.exports = __webpack_public_path__ + "img/failed_text.13219edf.png";